import { generateUtilityClasses } from '@mui/material';

import type { ThemeOptions } from '@mui/material';

declare module '@mui/material/InputBase' {
  interface InputBasePropsSizeOverrides {
    lg: true;
    md: true;
    medium: false;
    sm: true;
    small: false;
  }
}

export const textInputThemes: ThemeOptions['components'] = {
  MuiInputBase: {},
};

type TextInputEndAdornmentIconClasses = {
  clearIcon: string;
  errorIcon: string;
  loadingIcon: string;
  successIcon: string;
};

export const textInputEndAdornmentIconClasses: TextInputEndAdornmentIconClasses =
  generateUtilityClasses('TextInputEndAdornmentIcon', [
    'loadingIcon',
    'successIcon',
    'errorIcon',
    'clearIcon',
  ]);
